import React from "react";
import EditIcon from "@mui/icons-material/Edit";
const AboutUsHeader = ({ title, desc, handleOpen ,handleUpdate}) => {
  return (
    <>
      <div className="d-flex justify-content-between mt-3 mb-3 headerTable p-3">
        <div>
          <h6>{title}</h6>
        </div>
        <div className="desc d-flex">
          <div className="descCircle">
            <EditIcon className="icon" onClick={()=>{
              handleOpen();
              handleUpdate();
            }} />
          </div>
          <p>{desc}</p>
        </div>
      </div>
    </>
  );
};
export default AboutUsHeader;
